export const TERMS_AND_CONDITION_STATUS_OPTIONS = [
  { value: 'UNSIGNED', label: 'Unsigned' },
  { value: 'SIGNED', label: 'Signed' },
  { value: 'EXPIRED', label: 'Link Expired' },
  { value: 'UNSENT', label: 'Unsent' }
]

export const TICKET_STATUS_OPTIONS = [
  { value: 'OPEN', label: 'Open' },
  { value: 'EN_ROUTE', label: 'En Route' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'CANCELLED', label: 'Cancelled' }
]

export function clientSearchFormValues (source = {}) {
  return {
    accountId: source.accountId || undefined,
    accountName: source.accountName || undefined,
    contactName: source.contactName || undefined,
    phoneNumber: source.phoneNumber || undefined,
    termsAndConditionStatus: source.termsAndConditionStatus || undefined
  }
}

export function buildClientSearchFilters (source = {}) {
  return {
    accountName: source.accountName?.trim() || null,
    phoneNumber: source.phoneNumber?.trim() || null,
    contactName: source.contactName?.trim() || null,
    customId: source.accountId?.trim() || null,
    termsAndConditionStatus: source.termsAndConditionStatus?.trim() || null,
    clientId: source.clientId?.trim() || null
  }
}
